import { render } from "./CreateReturnRequest.vue?vue&type=template&id=88fa6da2&scoped=true"
import script from "./CreateReturnRequest.vue?vue&type=script&lang=js"
export * from "./CreateReturnRequest.vue?vue&type=script&lang=js"

import "./CreateReturnRequest.vue?vue&type=style&index=0&id=88fa6da2&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88fa6da2"]])

export default __exports__